import { changeEmailService } from '@afterpaytouch/portal-api/consumer/account/change-email'

export const {
  useChangeEmailVerifyMobileMutation,
  useChangeEmailReverifyMobileMutation,
  useChangeEmailCheckMobileMutation,
  useChangeEmailVerifyEmailMutation,
  useChangeEmailCheckEmailMutation,
} = changeEmailService
